import Text from 'components/corporatiu/Text';
import Titol from 'components/corporatiu/Titol';
import __isEmpty from 'lodash/isEmpty';
import styles from './historia.module.scss';
import Imatge from 'components/corporatiu/Imatge/Imatge';
import Desplegable from 'components/corporatiu/Desplegable';
import { getHidratationKey } from '@portal-internet/core';

export default function Historia(props) {
    const { items } = props;

    return (
        <>
            <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
            <div className={styles.imatge}>
                <Imatge src={items?.imatge} width={800} height={450} alt={items?.alt_imatge} priority={false} />
            </div>
            <div>
                {!__isEmpty(items) &&
                    items?.cronos.map((item, index) => (
                        <div key={`crono-${index}`} className='cronos'>
                            <div className='crono_item'>
                                <Desplegable
                                    key={getHidratationKey(item?.titol)}
                                    titol={item?.titol}
                                    className={styles.textDesplegable}
                                    tag='h2'
                                >
                                    <div className={styles.contingutDesplegable}>
                                        <Text text={item?.text} />
                                    </div>
                                </Desplegable>
                            </div>
                        </div>
                    ))}
            </div>
        </>
    );
}
